import { parsePostContent } from '@src/model/upvote/helpers';
import { type Post, PostStatus } from '@src/store/contentEntities/model';
import { getMainImageFromBlocks } from '@src/utils/editorjs-utils/editorjs-utils';

export type PostImageType = 'hero' | 'featured' | 'inline';

export function getAvailableImageTypeToDisplay(post: Post, preferredType: PostImageType): PostImageType {
    const hasHeroImage = Boolean(post.heroImage);
    const hasFeaturedImage = Boolean(post.featuredImage);

    if (preferredType === 'hero' && hasHeroImage) return 'hero';
    if (preferredType === 'featured' && hasFeaturedImage) return 'featured';
    if (hasHeroImage) return 'hero';
    if (hasFeaturedImage) return 'featured';
    return 'inline';
}

export function getPostImageUrl(post: Post, imageType: PostImageType = 'featured') {
    if (imageType === 'inline') return getMainImageFromBlocks(parsePostContent(post)?.blocks || []);
    return post[`${imageType}Image`];
}

export function isPostPublished(post?: Post) {
    if (!post) return false;
    if (typeof post.status !== 'number') return false;

    return [PostStatus.PUBLISHED, PostStatus.PUBLISHED_UNLISTED].includes(post.status);
}
